import loadTypes from 'utils/loadTypes'
import formatDate from 'date-fns/format'
import {groupByChannels, processTotal} from './utils'

export const INSIGHT_TRAFFIC = loadTypes('INSIGHT_TRAFFIC')
export const INSIGHT_TOTAL_CURRENT_TRAFFIC = loadTypes('INSIGHT_TOTAL_CURRENT_TRAFFIC')
export const INSIGHT_TOTAL_PREVIOUS_TRAFFIC = loadTypes('INSIGHT_TOTAL_PREVIOUS_TRAFFIC')
export const INSIGHT_TRAFFIC_SORTING = 'INSIGHT_TRAFFIC_SORTING'

function processTraffic(request, response) {
  if (!response) return null

  const channels = groupByChannels(response)

  return Object.keys(channels).reduce((acc, key) => {
    const channelData = channels[key]
    const {channel, channelGroup} = channelData[0].dimensions
    acc[`${channelGroup}/${channel}`] = channelData.reduce((acc, day) => {
      acc[formatDate(day.day, 'YYYY-MM-DD')] = {
        traffic: day['session:count'],
        cost: day['cost:total'],
        costPerVisit: day['cost:perVisit']
      }
      return acc
    }, {})
    return acc
  }, {})
}

const initialState = {
  data: null,
  costsStart: {},
  costsEnd: {},
  sortKey: 'trafficSum',
  sortDirection: 'desc',
  totalCurrent: null,
  totalPrevious: null,
  isFetching: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case INSIGHT_TRAFFIC.REQUEST:
      return {
        ...state,
        data: null,
        isFetching: true
      }
    case INSIGHT_TRAFFIC.SUCCESS:
      return {
        ...state,
        data: processTraffic(action.request, action.response),
        isFetching: false
      }
    case INSIGHT_TRAFFIC.FAILURE:
      return {
        ...state,
        data: null,
        isFetching: false
      }
    case INSIGHT_TRAFFIC_SORTING:
      return {
        ...state,
        ...{
          sortKey: action.sortKey,
          sortDirection: action.sortDirection
        }
      }

    case INSIGHT_TOTAL_CURRENT_TRAFFIC.SUCCESS:
      return {
        ...state,
        totalCurrent: processTotal(action.request, action.response)
      }

    case INSIGHT_TOTAL_PREVIOUS_TRAFFIC.SUCCESS:
      return {
        ...state,
        totalPrevious: processTotal(action.request, action.response)
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/insights/traffic.js